import { I18n } from "@aws-amplify/core";

export const createSiteDictionary = (languages, primaryLanguageId) => {
  const [language1, language2] = languages;
  if (!language2) return language1.dictionary;
  const reduceDirection =
    languages[0].id === primaryLanguageId ? "reduceRight" : "reduce";
  return languages[reduceDirection]((acc, curr) => {
    return Object.assign(acc, curr.dictionary);
  }, {});
};

export const setSiteDictionary = (languages, primaryLanguageId) => {
  const dictionary = createSiteDictionary(languages, primaryLanguageId);
  I18n.putVocabularies({ [primaryLanguageId]: dictionary });
  I18n.setLanguage(primaryLanguageId);
};
